<template>
  <v-container style="padding-top: 5rem; min-height: 100vh">
    <div class="screen index_screen">
        <div class="wrapper">
            <header>
                <span>
                  <!-- <i class="fa fa-chevron-left" aria-hidden="true"></i> -->
                  <a href="/" >뒤로가기</a>
                
                </span>
                <h1>회원가입</h1>
            </header>
            <div class="inner">
              

                <div class="sub_title_box">
                    <!-- <h2 class="sub_title">회원가입</h2> -->
                </div>
                <v-form ref="form" lazy-validation>

                    <p class="name ">
                        <label for='full-name'>이름</label>                        
                        <div class="name_box flex-deco-row">
                                          
                          <input id='full-name' name='full-name' v-model="uName" type='text' class="input_field"/>
                          
                              <!-- <input type="button" value="중복검사" @click="nickName()">
                              <h6 class="err_red_text">이미 사용중인 닉네임 입니다.</h6> -->
                          
                        </div>
                    </p>

                    <p class="tel">
                        <label for='tel'>전화번호</label>
                        <div class="tel_box flex-deco-row">
                            <input 
                              :readonly="this.isToken" 
                              :disabled="this.isToken"  
                              id='tel' name='tel' v-model="uPhone" type='number' class="input_field" placeholder="'-' 없이 입력" />
                            <input 
                              :disabled="this.isToken"  
                              type="button" value="인증번호 전송" @click="sendSms()" >
                            <h6 class="err_red_text">잘못된 인증번호입니다.</h6>
                        </div>
                    </p> 

                    <div class="" v-show="this.tokenChk != false ? true : false ">
                        <p class="tel "  >
                            <label for='tel'>인증번호</label>
                            <div class="tel_box flex-deco-row">
                                <input 
                                  :readonly="this.isToken" 
                                  :disabled="this.isToken" 
                                  id='token' name='token' v-model="token" type='number' class="input_field" placeholder="" />
                                <input type="button" value="확인" @click="checkSms()" :disabled="this.isToken" >
                                <h6 class="err_red_text">잘못된 인증번호입니다.</h6>
                            </div>
                        </p> 
                    </div>
                    


                    <p class="grade">
                        <label for="pet-select">직급</label>
                        <select name="pets" id="pet-select" v-model="uGrade">
                          <!--
                            <option value="3">사장</option>
                            <option value="2">전무</option>
                          -->
                            <option value="2">관리자</option>
                            <option value="1">스태프</option>
                        </select>
                    </p> 

                    <p>
                        <label for="re_tel">추천인번호(핸드폰)</label>
                        <input type="text" id="re_tel" v-model="recommend"  class="input_field">
                    </p>
                
                    <!-- <a class="pay_btn" style="color:white">가입하기</a> -->
                    <v-btn
                      class="pay_btn"
                      color="primary"                    
                      @click="onSubmit"
                      :disabled="loading"
                    >
                      가입하기
                    </v-btn>           

                </v-form>
            </div>            
          
        </div>         
    </div>

 
          <!-- <v-text-field
            type="number"
            v-model="token"
            :error-messages="error"
            :rules="[rules.required]"
            class="my-4"
            clearable
            required
            v-on:keyup.enter="onSubmit"
            label="인증번호"
          ></v-text-field>
          <v-text-field
            type="text"
            v-model="recommend"
            class="my-4"
            clearable
            required
            label="추천인"
            v-on:keyup.enter="onSubmit"
          ></v-text-field> -->
          <!-- <v-select :items="psiteList" v-model="psite" required label="매장">
          </v-select> -->
        
  </v-container>
</template>

<script>
import '@/staff/css/style.css'    
import '@/staff/css/0908_style.css'

import { copyTimestamp } from 'vuetify/lib/components/VCalendar/util/timestamp';


export default {
  data: () => ({
    uName:'' , 
    uPhone : '' , 
    uGrade : '' ,     
    token: '',
    tokenChk: '',
    tokenPhone : '' , 
    recommend: '',
    isToken: false ,
    psite: '',    
    psiteList: [],
    rules: {
      required: (value) => !!value || '인증코드를 입력하세요.'
    },
    error: ''
  }),
  computed: {
    loading() {
      return this.$store.getters.loading
    }
  },
  methods: {
     phoneChk( phone ){
      var regExp = /^(?:(010\d{4})|(01[1|6|7|8|9]\d{3,4}))(\d{4})$/;
      if(!regExp.test(phone)){
        // alert("휴대폰번호가 올바르지 않습니다.");
        return false;
      }
      return true;
    } ,  
    nickName(){
      alert(this.userName )
    }, 
    tokenInit(){
      this.token = '' ;
      this.tokenChk = ''; 
      this.tokenPhone = '' ;  
    } ,
    checkSms(){
      if( this.tokenPhone != this.uPhone ){
        alert('인증요청 핸드폰 번호가 다릅니다 ') ; 
        this.tokenInit(); 
        return false ; 
      }; 

      if( this.token != this.tokenChk ) {
        alert('인증코드를 확인해 주세요.') ; 
        return false ; 
      } 

      alert('인증되었습니다.') ; 
      this.isToken = true ;      

    },  
 
    sendSms(){
            
      if( !this.uPhone  || this.uPhone ==''  ) {
        alert("핸드폰 번호를 확인해 주세요 ");  
        return false ;
      } ; 

      if ( !this.phoneChk (this.uPhone ) ) {
        alert("핸드폰 번호를 확인해 주세요 ");  
        return false ; 
      } 


      // AUTH_CODE 
      this.$store
        .dispatch('auth_code' , {proc : 'code' ,  phone : this.uPhone } )
        .then((res) => {
          // console.log( res.data)
          
            if (res.data.tokenChk && isNaN(this.tokenChk) == false ) {
              this.tokenChk  = res.data.tokenChk ; 
              this.tokenTime = res.data.tokenTime ; 
              this.tokenPhone  = this.uPhone ; 
              alert('인증문자가 발송되었습니다. ') ; 
              // if( isNaN(this.tokenChk) == false  ) { }
            } else if (res.data.code === 'invalid') {
              this.error = '가입된 핸드폰 번호입니다.'
              alert(this.error) ; 

            }else{
              alert('잠시후 다시 시도해주세요.')
            }
          

            // res.data.
            // const data = res.data.data
            // this.psiteList = Object.keys(data).map((item) => ({
            //   text: data[item],
            //   value: item
            // }))

          
        })
        .catch((err) => {
          this.error = '인터넷 연결이 불안정합니다. 잠시후 다시 시도해주세요.'
        }) ;


    },
    onSubmit() {
 
      if( this.uName == '' ) { alert('이름을 입력해주세요.'); return false ; }
      if( this.uPhone == '' ) { alert('전화번호를 입력해주세요.'); return false ; }
      if( this.uGrade == '' ) { alert('직급을 선택해주세요.'); return false ; }
      if( this.isToken != true  ) { alert('전화번호 인증 필수입니다.'); return false ; } 
      if( this.recommend == '' ) { alert('추천인 핸드폰 전화번호를 입력해주세요.'); return false ; }
      if ( !this.phoneChk (this.recommend ) ) {
        alert("추천인(핸드폰) 번호를 확인해 주세요 ");  
        return false ; 
      }  
      
      this.$store.commit('loading', true)
        const params = {
          proc : 'submit' , 
          uname : this.uName.trim() ,
          phone: this.uPhone.trim() ,
          grade : this.uGrade.trim()  ,
          token: this.token.trim(),
          recommend: this.recommend.trim(),          
        } ; 

        this.$store
          .dispatch('AUTH_CODE' , params  )
          .then((res) => {
            this.$store.commit('loading', false)
            console.log( res ) ;
            if (!res) {
              throw new Error('no response')
            } else if (res.status) {

              
              const token = res.token
                 

                    // commit('is_login', true)
                    // commit('MUTATION_LOGIN', token)
                    // // resolve(response.data)
                    this.$cookies.remove('psite')
                    this.$cookies.remove('recommend')
                    this.$router.push('/home')

              // // return 
              //  new Promise((resolve, reject) => {
              //   if (response.data.status) {
              //     const token = response.data.token
              //     commit('is_login', true)
              //     commit('MUTATION_LOGIN', token)
              //     // resolve(response.data)
              //     this.$cookies.remove('psite')
              //     this.$cookies.remove('recommend')
              //     this.$router.push('/home')

              //   } else {
              //     //   resolve(response.data)
              //   }
              // })


              // if (this.autoLogin) {
              //   localStorage.accessToken = res.token
              // }
              // this.$store.dispatch('FETCH_USERINFO').then((res) => {
              // this.$store.commit('loading', false)

              //   try {
              //     loginSuccess(this.email, res.token)
              //   } catch (error) {
              //     this.$store.commit('loading', false)
              //     console.log(error)
              //   }
              //   if (!res.data.user.auth_sms || res.data.user.auth_sms === 'N') {
              //     this.$router.push('/phone/verify')
              //     return
              //   }

              //   this.$store.commit('activeMenu', 'home')
              // })



              // this.$cookies.remove('psite')
              // this.$cookies.remove('recommend')
              // this.$router.push('/home')
              
            } else if (res.code === 'invalid') {
              this.error = '가입된 핸드폰 번호입니다.'
              alert(this.error) ; 
            } else if (res.code === 'token') {
              this.error = '잘못된 인증번호 입니다.'
              alert(this.error) ; 
            } else if (res.code === 'timeout') {
              this.error = '인증번호 유효시간이 초과되었습니다.'
              alert(this.error) ;               
            }
          })
          .catch((err) => {
console.error ("err:: " , err )
            this.error = '인터넷 연결이 불안정합니다. 잠시후 다시 시도해주세요.'
            alert(this.error) ;  
          })
      
    }
  },
  created() {
  


    // this.$store
    //   .dispatch('psite')
    //   .then((res) => {
    //     // console.log(res)
    //     if (res.data.result) {
    //       const data = res.data.data
    //       this.psiteList = Object.keys(data).map((item) => ({
    //         text: data[item],
    //         value: item
    //       }))
    //     } else throw res
    //   })
    //   .catch((err) => {
    //     this.error = '인터넷 연결이 불안정합니다. 잠시후 다시 시도해주세요.'
    //   })
    // if (!this.$route.params.phone) this.$router.replace('/signin')
    // const psite = this.$cookies.get('psite')
    // if (psite) this.psite = psite
    // const recommend = this.$cookies.get('recommend')
    // if (recommend) this.recommend = recommend
  }
}
</script>

<style>
.flex-deco-row { flex-direction:row; }
.flex-deco-row #tel {width: 60%;}
.dis_n {display: none;}
.dis_b {display: block;}

.desc-box {
  background-color: #f1f1f1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 2rem;
  margin: 1rem 0;
}
</style>

 